const { v4: uuidv4 } = require('uuid');
const { AuthServiceMethods } = require('../constants');

const methodWithNewEndpointVersion = [AuthServiceMethods.GENERATE_OTT];

const getFormattedQuery = (payload) => {
  const headers = {};

  if (methodWithNewEndpointVersion.includes(payload.method)) {
    headers['x-winamax-public-endpoint-version'] = 2;
  }

  return {
    method: 'POST',
    credentials: 'same-origin',
    headers,
    body: JSON.stringify(payload),
  };
};

const computeExpirationInfos = (expirationDelay) => {
  const randomDelay = (30 + Math.round(Math.random() * 120)) * 1000;
  const refreshTimeout = expirationDelay * 1000 - randomDelay;

  return { refreshTimeout };
};

const secInMs = (sec) => sec * 1000;
const minInMs = (min) => min * 60000;

const computeExpirationInfosAfterRefresh = () => {
  const refreshTimeout = minInMs(10);
  const expirationDelay = minInMs(18) - secInMs(Math.round(Math.random() * 120));

  return { refreshTimeout, expirationDelay };
};

const tryToClearTimeout = (ref, which) => {
  if (ref && ref[which]) {
    clearTimeout(ref[which]);
    // eslint-disable-next-line no-param-reassign
    ref[which] = null;
  }
};

const clearPendingTimeout = (ref) => {
  if (ref) {
    Object.keys(ref).forEach((key) => {
      if (ref[key]) {
        clearTimeout(ref[key]);
        // eslint-disable-next-line no-param-reassign
        ref[key] = null;
      }
    });
  }
};

const fetchApi = async (endpoint, { method, ns, params }) => {
  const target = `${endpoint}/${ns}`;
  const payload = {
    id: uuidv4(),
    method,
    ns,
    ts: Date.now(),
    params,
  };

  try {
    const response = await fetch(target, getFormattedQuery(payload));

    if (response) {
      const res = await response.json();
      return res;
    }
  } catch (err) {
    return { error: 'General problem' };
  }

  return {};
};

module.exports = {
  computeExpirationInfos,
  computeExpirationInfosAfterRefresh,
  tryToClearTimeout,
  clearPendingTimeout,
  fetchApi,
};
